import React from 'react';
import {CardContainer} from 'components/common/uiKit'
import {connect} from "react-redux";

class NoRecord extends React.Component {

    render() {
        const {message} = this.props;

        const {locale} = this.props;
        const pageTranslates = locale.translation.Components.NoRecord;

        return (
            <CardContainer>
                <div className='text-center'>
                    <h6 className='text-center color-primary'>
                        {pageTranslates[message]}
                    </h6>
                </div>
            </CardContainer>
        );
    }
}

const mapStateToProps = state => {
    const {locale} = state;
    return {locale};
};

export default connect(mapStateToProps, null)(NoRecord);
